import { Reveal } from "./Reveal";
import { Percent, ShieldCheck, Zap, Users, Copyright, Headphones } from "lucide-react";

const G1 = "https://images.pexels.com/photos/1917687/pexels-photo-1917687.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const G2 = "https://images.unsplash.com/photo-1783602451496-d05cfafa6eeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGNvdXBsZSUyMHZhY2F0aW9uJTIwYmVhY2h8ZW58MHx8fHwxNzg0ODk4MTM5fDA&ixlib=rb-4.1.0&q=85";
const G3 = "https://images.unsplash.com/photo-1610641818989-c2051b5e2cfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxyZXNvcnQlMjBzd2ltbWluZyUyMHBvb2wlMjBsaWZlc3R5bGV8ZW58MHx8fHwxNzg0ODk4MTQwfDA&ixlib=rb-4.1.0&q=85";

const benefits = [
  { icon: Percent, title: "80 % pour vous", text: "La commission la plus généreuse du marché. Vous gardez la plus grosse part." },
  { icon: Zap, title: "Payé sous 24 h", text: "Reversement rapide après chaque vente confirmée." },
  { icon: ShieldCheck, title: "Paiement Stripe", text: "Transactions sécurisées et conformes, sans effort de votre part." },
  { icon: Users, title: "Audience captive", text: "Des milliers de vacanciers en quête de leurs souvenirs." },
  { icon: Copyright, title: "Vos droits restent vôtres", text: "Licence non exclusive : vous conservez la propriété de vos œuvres." },
  { icon: Headphones, title: "Zéro logistique", text: "Hébergement, vente, paiement, support : on s'occupe de tout." },
];

const Photo = ({ src, alt, className }) => (
  <div className={`relative overflow-hidden group ${className}`}>
    <img src={src} alt={alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
  </div>
);

const Benefit = ({ b, className }) => {
  const Icon = b.icon;
  return (
    <div className={`bg-[#F9FAFB] border border-[#E4E4E7] p-6 md:p-8 flex flex-col ${className}`} data-testid={`benefit-${b.title}`}>
      <Icon className="w-6 h-6 text-[#F97316]" />
      <h3 className="mt-5 text-lg font-bold tracking-tight text-[#0A0A0A]">{b.title}</h3>
      <p className="mt-2 text-sm text-[#52525B] font-light leading-relaxed">{b.text}</p>
    </div>
  );
};

export default function WhyIFotoLife() {
  return (
    <section id="pourquoi" className="py-24 md:py-32 border-y border-[#E4E4E7] bg-white scroll-mt-20" data-testid="why-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="text-xs font-black uppercase tracking-label text-[#F97316] mb-4">Pourquoi iFotoLife</div>
          <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-[#0A0A0A] max-w-3xl leading-tight">
            Fait pour les photographes qui veulent vendre, pas gérer.
          </h2>
        </Reveal>

        {/* Asymmetric tetris grid */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-auto">
          <Reveal className="md:col-span-5" delay={0.05}><Benefit b={benefits[0]} className="h-full" /></Reveal>
          <Reveal className="md:col-span-4" delay={0.1}><Photo src={G1} alt="Piscine de resort" className="h-full min-h-[220px]" /></Reveal>
          <Reveal className="md:col-span-3" delay={0.15}><Benefit b={benefits[1]} className="h-full" /></Reveal>

          <Reveal className="md:col-span-4" delay={0.05}><Benefit b={benefits[2]} className="h-full" /></Reveal>
          <Reveal className="md:col-span-4" delay={0.1}><Benefit b={benefits[3]} className="h-full" /></Reveal>
          <Reveal className="md:col-span-4" delay={0.15}><Photo src={G2} alt="Couple en vacances" className="h-full min-h-[220px]" /></Reveal>

          <Reveal className="md:col-span-4" delay={0.05}><Photo src={G3} alt="Palmiers et piscine" className="h-full min-h-[220px]" /></Reveal>
          <Reveal className="md:col-span-4" delay={0.1}><Benefit b={benefits[4]} className="h-full" /></Reveal>
          <Reveal className="md:col-span-4" delay={0.15}><Benefit b={benefits[5]} className="h-full" /></Reveal>
        </div>
      </div>
    </section>
  );
}
